import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { v4 as uuidv4 } from 'uuid'
import { RootState } from '../rootReducer'
import { ReactNode } from 'react'

export type AlertItem = {
  id: string
  message: string | ReactNode
  type: 'error' | 'info' | 'warning' | 'success'
}

export type CreateAlertItem = Pick<AlertItem, 'message' | 'type'> & {
  id?: string
}

export type AlertsReducerState = Record<string, AlertItem[]>

const initialState: AlertsReducerState = {}

export const selectAlertsByArea = (state: RootState, area: string): AlertItem[] => state.alert[area] ?? []

export const AlertsSlice = createSlice({
  name: 'alerts',
  initialState,
  reducers: {
    appendAlert(state, action: PayloadAction<{ area: string; alert: CreateAlertItem }>) {
      const { area, alert } = action.payload
      state[area] = state[area] ?? []

      state[area].push({ ...alert, id: alert.id ?? uuidv4() })
    },
    dismissAlert(state, action: PayloadAction<{ area: string; alertId: string }>) {
      const { area, alertId } = action.payload
      state[area] = state[area]?.filter((alert) => alert.id !== alertId) ?? []
    },
    replaceAlerts(state, action: PayloadAction<{ area: string; alerts: CreateAlertItem[] }>) {
      const { area, alerts } = action.payload
      state[area] = alerts.map((alert) => ({ ...alert, id: alert.id ?? uuidv4() }))
    },
  },
})

export const { appendAlert, dismissAlert, replaceAlerts } = AlertsSlice.actions

export default AlertsSlice.reducer
